export default __webpack_public_path__ + "static/media/empty-cart.986a5e29.svg";